import React from 'react'
import { Spinner } from 'react-bootstrap';
import '../Styles/Components/AppSpinner.scss';

export default function AppSpinner(props) {
    return (
        <div className={`AppSpinner ${props.fullHeight ? "Full-Height" : ""}`}>
            <Spinner
                as="span"
                animation="grow"
                role="status"
                aria-hidden="true"
            />
            {
                props.loadingtext ? <span>{props.loadingtext}</span> : null
            }
        </div>
    )
}
